var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('TopSortEdit',{attrs:{"areaID":1,"q":_vm.q,"topSort":_vm.topSortHochsee}})],1),_c('div',{staticClass:"col-md-6"},[_c('TopSortEdit',{attrs:{"areaID":2,"q":_vm.q,"topSort":_vm.topSortFluss}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }